import { useState } from "react"


const CageForm = ({setCageData, setContractData}) => {
    console.log(setContractData, "HERE")
    //create state
    const [cage, setCage] = useState('')
    const [error, setError] = useState('')

    const handleSubmit = async (e) =>{
        e.preventDefault()

        const cageUrl = 'https://postgres-nsn-search-tau.vercel.app/api/cage/' + cage;

        const cageResponse = await fetch(cageUrl, {
            method:'GET'
        })
        const cData = await cageResponse.json()

        if (!cageResponse.ok) {
            setError(cData.error)
            console.log(error)
        } else {
            setCage('')
            setCageData(cData)
            setError(null)
        }

        const contractUrl = 'https://postgres-nsn-search-tau.vercel.app/api/cageContracts/' + cage;

        const contractResponse = await fetch(contractUrl, {
            method:'GET'
        })
        const coData = await contractResponse.json()

        if (!cageResponse.ok) {
            setError(coData.error)
            console.log(error)
        } else {
            setCage('')
            setContractData(coData)
            setError(null)
        }
    }

    return ( 
       <form className="search" onSubmit={handleSubmit}>
        <h3>Cage Lookup</h3>
        <input
            type="number"
            name="cageInput"
            onChange={(e) => setCage(e.target.value)}
            value={cage}
        />

        <button>Enter</button>
        
       </form>
    

    )
}

export default CageForm;